<div *ngIf="position == 'top'" style="display: table; margin: 0 auto;">
        <a rel="noopener" href="https://nationalparalegal.edu/">
                <img src="/assets/img/banners/NPCbanner-desktop.gif" alt="National Paralegal College banner desktop"
                        class="banner-desktop" />
                <img src="/assets/img/banners/NPCbanner-mobile.gif" alt="National Paralegal College banner mobile"
                        class="banner-mobile" />
        </a>
        <br>
</div>